module.exports = __webpack_public_path__ + "img/skier-type-3.c11a3929.png";